<template>
    <div class="">
        <MultiSelect 
            @select="onSelect" 
            :options="filterData" 
            :selected-options="data"
            :placeholder="placeholder">
        </MultiSelect>
    </div>
</template>


<script>

import { MultiSelect } from 'vue-search-select';

export default {
    components: {
        MultiSelect,
    },
    mounted() {

    },
    data() {
        return {
            data: [],
        };
    },
    props: {
        modelValue: {},
        filterData: {},
        placeholder: {},
    },
    methods: {
        onSelect(items) {
            this.data = items;
            this.$emit('update:modelValue', [...items]);
        },
    },
}
</script>

<style scoped></style>